var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_1403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8129 7.50439L21.8562 1.65812C21.0277 0.907354 19.765 0.907354 18.9365 1.65812L12.9799 7.50439",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1213 18.6035L36.3248 21.395",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7671 33.9306L39.7814 42.731",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46787 21.395L1.67145 18.6035",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0254 33.9306L1.01123 42.731",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4749 44.9048H37.6079C38.8086 44.9048 39.7819 43.9314 39.7819 42.7308V20.1762C39.7819 19.5846 39.5441 19.0178 39.1219 18.6035L36.3254 15.8589",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01129 30.6017V42.7308C1.01129 43.9314 1.98463 44.9048 3.1853 44.9048H27.5934",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46765 15.8587L1.67123 18.6033C1.24908 19.0177 1.01117 19.5845 1.01117 20.176V27.7202",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3251 11.2763V9.70823C36.3251 8.49116 35.3384 7.50451 34.1214 7.50451H6.67137C5.4543 7.50451 4.46765 8.49116 4.46765 9.70823V21.3951L17.0254 33.9307L19.3493 32.6537C20.0014 32.2952 20.7914 32.2952 21.4434 32.6537L23.7673 33.9307L36.3251 21.3951V14.0904",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4775 18.524C22.4775 20.2916 21.3926 21.6152 20.0939 21.6152C18.7952 21.6152 17.6467 20.3099 17.6467 18.5424C17.6467 16.7747 18.859 15.5971 20.1578 15.5971C21.4564 15.5971 22.4775 16.7564 22.4775 18.524Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2711 24.6074C17.6879 24.5359 15.3326 22.7876 14.6331 20.1283C13.8259 17.0588 15.5915 13.8529 18.6158 12.8902C21.8144 11.8719 25.2161 13.6714 26.1826 16.8737C26.5246 18.1549 26.325 19.2696 25.8719 20.4091C25.6921 20.8608 25.0995 21.9185 23.7813 21.9185C23.0617 21.9185 22.4618 21.2289 22.4657 20.4345L22.4917 15.1703",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1823 16.8733C26.5243 18.1546 26.3247 19.2693 25.8716 20.4087",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_1403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.7924,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e8757f86bbcbaa80cdc50dfde0a3a3c2.svg";
export { ForwardRef as ReactComponent };